(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/my-information/my-information-service.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/my-information/my-information-service.js');
'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const jupiter = svs.core.jupiter;
const logger = svs.myProfile.logger;
const svsFetch = svs.core.svsFetch.create();

const getCustomersPreferencesAsync = async () => {
  const useOldJupiterApi = !svs.core.detect.feature('ft-elza-my-profile');
  if (useOldJupiterApi) {
    try {
      const path = '/player/1/preferences';
      const _await$jupiter$callAs = await jupiter.callAsync({
          method: 'GET',
          path,
          data: {}
        }),
        response = _await$jupiter$callAs.response;
      if (response !== null && response !== void 0 && response.error) {
        logger.warn('Error when fetching player preferences', response === null || response === void 0 ? void 0 : response.error);
      }
      return {
        error: response === null || response === void 0 ? void 0 : response.error,
        playerPreferences: (response === null || response === void 0 ? void 0 : response.preferences[30]) || {}
      };
    } catch (err) {
      logger.warn('Error when fetching player preferences', err);
      return {
        error: err,
        playerPreferences: {}
      };
    }
  }
  try {
    var _contacts$addresses, _contacts$addresses2, _contacts$addresses3, _contacts$email, _contacts$email$statu, _contacts$email2, _contacts$cellPhone, _contacts$cellPhone$s, _contacts$cellPhone2;
    const _await$Promise$all = await Promise.all([svsFetch('/contacts/v1/customers/me', {
        method: 'GET'
      }), svsFetch('/player-accounts/v1/customers/me', {
        method: 'GET'
      })]),
      _await$Promise$all2 = _slicedToArray(_await$Promise$all, 2),
      contactsResponse = _await$Promise$all2[0],
      accountResponse = _await$Promise$all2[1];
    if (!contactsResponse.ok || !accountResponse.ok) {
      const failedResponse = !contactsResponse.ok ? contactsResponse : accountResponse;
      if (failedResponse.status === 401) {
        window.location.href = '/logga-ut';
        return {
          error: {
            code: 401,
            message: 'unauthorized'
          },
          playerPreferences: {}
        };
      }
      try {
        const body = await failedResponse.json();
        const errorDetail = (body === null || body === void 0 ? void 0 : body.title) || (body === null || body === void 0 ? void 0 : body.detail) || 'Error when fetching player preferences';
        logger.warn('Error when fetching player preferences (Elza):', failedResponse.status, body === null || body === void 0 ? void 0 : body.type, errorDetail);
        return {
          error: {
            code: Number(body === null || body === void 0 ? void 0 : body.errorCode) || failedResponse.status,
            message: errorDetail
          },
          playerPreferences: {}
        };
      } catch (_unused) {
        logger.error('Error when fetching player preferences (Elza)', failedResponse.status);
        return {
          error: {
            code: failedResponse.status,
            message: 'Error when fetching player preferences'
          },
          playerPreferences: {}
        };
      }
    }
    const contactsData = await contactsResponse.json();
    const accountData = await accountResponse.json();
    const contacts = (contactsData === null || contactsData === void 0 ? void 0 : contactsData.data) || {};
    const account = (accountData === null || accountData === void 0 ? void 0 : accountData.data) || {};
    const playerPreferences = {
      cid: String(account.customerId || ''),
      name: account.firstName || '',
      surname: account.lastName || '',
      address: ((_contacts$addresses = contacts.addresses) === null || _contacts$addresses === void 0 || (_contacts$addresses = _contacts$addresses[0]) === null || _contacts$addresses === void 0 ? void 0 : _contacts$addresses.street) || '',
      postcode: ((_contacts$addresses2 = contacts.addresses) === null || _contacts$addresses2 === void 0 || (_contacts$addresses2 = _contacts$addresses2[0]) === null || _contacts$addresses2 === void 0 ? void 0 : _contacts$addresses2.zipCode) || '',
      location: ((_contacts$addresses3 = contacts.addresses) === null || _contacts$addresses3 === void 0 || (_contacts$addresses3 = _contacts$addresses3[0]) === null || _contacts$addresses3 === void 0 ? void 0 : _contacts$addresses3.town) || '',
      email: ((_contacts$email = contacts.email) === null || _contacts$email === void 0 ? void 0 : _contacts$email.address) || '',
      emailStatus: String((_contacts$email$statu = (_contacts$email2 = contacts.email) === null || _contacts$email2 === void 0 || (_contacts$email2 = _contacts$email2.status) === null || _contacts$email2 === void 0 ? void 0 : _contacts$email2.code) !== null && _contacts$email$statu !== void 0 ? _contacts$email$statu : ''),
      cellphone: ((_contacts$cellPhone = contacts.cellPhone) === null || _contacts$cellPhone === void 0 ? void 0 : _contacts$cellPhone.number) || '',
      cellPhoneStatus: String((_contacts$cellPhone$s = (_contacts$cellPhone2 = contacts.cellPhone) === null || _contacts$cellPhone2 === void 0 || (_contacts$cellPhone2 = _contacts$cellPhone2.status) === null || _contacts$cellPhone2 === void 0 ? void 0 : _contacts$cellPhone2.code) !== null && _contacts$cellPhone$s !== void 0 ? _contacts$cellPhone$s : '')
    };
    return {
      error: undefined,
      playerPreferences
    };
  } catch (err) {
    logger.warn('Error when fetching player preferences (Elza)', err);
    return {
      error: {
        code: 'network-error',
        message: err === null || err === void 0 ? void 0 : err.message
      },
      playerPreferences: {}
    };
  }
};
const getCustomerBankAccountsAsync = async () => {
  const useOldJupiterApi = !svs.core.detect.feature('ft-elza-my-profile');
  if (useOldJupiterApi) {
    try {
      const path = '/player/1/bankaccounts';
      const _await$jupiter$callAs2 = await jupiter.callAsync({
          method: 'GET',
          path,
          data: {}
        }),
        response = _await$jupiter$callAs2.response;
      if (response !== null && response !== void 0 && response.error) {
        logger.warn('Error when fetching player bankaccounts', response === null || response === void 0 ? void 0 : response.error);
      }
      return {
        error: response === null || response === void 0 ? void 0 : response.error,
        bankAccount: response === null || response === void 0 ? void 0 : response.bankAccounts[0]
      };
    } catch (err) {
      logger.warn('Error when fetching player bankaccounts', err);
      return {
        error: err,
        bankAccount: {}
      };
    }
  }
  try {
    var _data$status;
    const response = await svsFetch('/bank-accounts/v1/customers/me', {
      method: 'GET'
    });
    if (!response.ok) {
      if (response.status === 401) {
        window.location.href = '/logga-ut';
        return {
          error: {
            code: 401,
            message: 'unauthorized'
          },
          bankAccount: {}
        };
      }
      try {
        const body = await response.json();
        const errorDetail = (body === null || body === void 0 ? void 0 : body.title) || (body === null || body === void 0 ? void 0 : body.detail) || 'Error when fetching player bankaccounts';
        logger.warn('Error when fetching player bankaccounts (Elza):', response.status, body === null || body === void 0 ? void 0 : body.type, errorDetail);
        return {
          error: {
            code: Number(body === null || body === void 0 ? void 0 : body.errorCode) || response.status,
            message: errorDetail
          },
          bankAccount: {}
        };
      } catch (_unused2) {
        logger.error('Error when fetching player bankaccounts (Elza)', response.status);
        return {
          error: {
            code: response.status,
            message: 'Error when fetching player bankaccounts'
          },
          bankAccount: {}
        };
      }
    }
    const responseData = await response.json();
    const data = (responseData === null || responseData === void 0 ? void 0 : responseData.data) || {};
    const bankAccount = {
      clearingNumber: data.clearingNumber || '',
      accountNumber: data.accountNumber || '',
      bankName: data.bankName || '',
      status: ((_data$status = data.status) === null || _data$status === void 0 ? void 0 : _data$status.name) || ''
    };
    return {
      error: undefined,
      bankAccount
    };
  } catch (err) {
    logger.warn('Error when fetching player bankaccounts (Elza)', err);
    return {
      error: {
        code: 'network-error',
        message: err === null || err === void 0 ? void 0 : err.message
      },
      bankAccount: {}
    };
  }
};

const putSendMobileVerificationCodeAsync = async () => {
  const useOldJupiterApi = true; 
  if (useOldJupiterApi) {
    try {
      const path = '/player/1/phones/verify';
      const response = await jupiter.callAsync({
        method: 'PUT',
        path,
        data: {}
      });
      if (response !== null && response !== void 0 && response.error) {
        logger.warn('Error when trying to verify phone', response === null || response === void 0 ? void 0 : response.error);
      }
      return {
        error: response === null || response === void 0 ? void 0 : response.error
      };
    } catch (err) {
      logger.warn('Error when trying to verify phone', err);
      return {
        error: err
      };
    }
  }
  try {
    const response = await svsFetch('/contacts/v1/customers/me/cellphone/order', {
      method: 'PUT'
    });
    if ((response === null || response === void 0 ? void 0 : response.status) === 204) {
      return {
        error: undefined
      };
    }
    if (!response.ok) {
      if (response.status === 401) {
        window.location.href = '/logga-ut';
        return {
          error: {
            code: 401,
            message: 'unauthorized'
          }
        };
      }
      try {
        const body = await response.json();
        const errorDetail = (body === null || body === void 0 ? void 0 : body.detail) || 'Error when trying to verify phone';
        logger.warn('Error when trying to verify phone /contacts/v1/customers/me/cellphone/order:', response.status, errorDetail);
        return {
          error: {
            code: response.status,
            message: errorDetail
          }
        };
      } catch (_unused3) {
        logger.error('Error when trying to verify phone, /contacts/v1/customers/me/cellphone/order', response.status);
        return {
          error: {
            code: response.status,
            message: 'Error when trying to verify phone'
          }
        };
      }
    }
    return {
      error: undefined
    };
  } catch (err) {
    logger.warn('Error when trying to verify phone', err);
    return {
      error: {
        code: 'network-error',
        message: err === null || err === void 0 ? void 0 : err.message
      }
    };
  }
};

const postConfirmMobileNumberAsync = async code => {
  try {
    const path = '/player/1/phones/confirmation';
    const _await$jupiter$callAs3 = await jupiter.callAsync({
        method: 'POST',
        path,
        data: {
          code
        }
      }),
      response = _await$jupiter$callAs3.response;
    if (response !== null && response !== void 0 && response.error) {
      logger.warn('Error confirming phone number', response === null || response === void 0 ? void 0 : response.error);
    }
    return {
      error: response === null || response === void 0 ? void 0 : response.error
    };
  } catch (err) {
    logger.warn('Error confirming phone number', err);
    return {
      error: err
    };
  }
};

const postEmailAsync = async email => {
  const useOldJupiterApi = true; 

  if (useOldJupiterApi) {
    try {
      const _await$jupiter$callAs4 = await jupiter.callAsync({
          method: 'PUT',
          path: '/player/1/email',
          data: {
            email
          }
        }),
        response = _await$jupiter$callAs4.response;
      if (response !== null && response !== void 0 && response.error) {
        logger.warn('Error posting email', response === null || response === void 0 ? void 0 : response.error);
      }
      return {
        error: response === null || response === void 0 ? void 0 : response.error
      };
    } catch (err) {
      logger.warn('Error posting email', err);
      return {
        error: err
      };
    }
  }
  try {
    const response = await svsFetch('/contacts/v1/customers/me', {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        email
      })
    });
    if ((response === null || response === void 0 ? void 0 : response.status) === 204) {
      return {
        error: undefined
      };
    }
    if (!response.ok) {
      if (response.status === 401) {
        window.location.href = '/logga-ut';
        return {
          error: {
            code: 401,
            message: 'unauthorized'
          }
        };
      }
      try {
        const body = await response.json();
        const errorDetail = (body === null || body === void 0 ? void 0 : body.title) || (body === null || body === void 0 ? void 0 : body.detail) || 'Error posting email';
        logger.warn('Error posting email (Elza):', response.status, body === null || body === void 0 ? void 0 : body.type, errorDetail);
        return {
          error: {
            code: Number(body === null || body === void 0 ? void 0 : body.errorCode) || response.status,
            message: errorDetail
          }
        };
      } catch (_unused4) {
        logger.error('Error posting email (Elza)', response.status);
        return {
          error: {
            code: response.status,
            message: 'Error posting email'
          }
        };
      }
    }
    return {
      error: undefined
    };
  } catch (err) {
    logger.warn('Error posting email (Elza)', err);
    return {
      error: {
        code: 'network-error',
        message: err === null || err === void 0 ? void 0 : err.message
      }
    };
  }
};

const postCellPhoneAsync = async cellPhone => {
  try {
    const _await$jupiter$callAs5 = await jupiter.callAsync({
        method: 'PUT',
        path: '/player/1/phones',
        data: {
          cellPhone
        }
      }),
      response = _await$jupiter$callAs5.response;
    if (response !== null && response !== void 0 && response.error) {
      logger.warn('Error posting cellphone', response === null || response === void 0 ? void 0 : response.error);
    }
    return {
      error: response === null || response === void 0 ? void 0 : response.error
    };
  } catch (err) {
    logger.warn('Error posting cellphone', err);
    return {
      error: err
    };
  }
};
const deleteCellPhoneAsync = async () => {
  const useOldJupiterApi = !svs.core.detect.feature('ft-elza-delete-cell');
  if (useOldJupiterApi) {
    try {
      const _await$jupiter$callAs6 = await jupiter.callAsync({
          method: 'DELETE',
          path: '/player/1/cellphone',
          data: {}
        }),
        response = _await$jupiter$callAs6.response;
      if (response !== null && response !== void 0 && response.error) {
        return {
          error: response === null || response === void 0 ? void 0 : response.error
        };
      }
      return {
        error: null
      };
    } catch (err) {
      return {
        error: {
          code: 'network-error'
        }
      };
    }
  }
  try {
    const response = await svsFetch('/contacts/v1/customers/me/cellphone', {
      method: 'DELETE'
    });
    if ((response === null || response === void 0 ? void 0 : response.status) === 204) {
      return {
        error: null
      };
    }
    if (!response.ok) {
      if (response.status === 401) {
        window.location.href = '/logga-ut';
        return {
          error: {
            code: 401,
            message: 'unauthorized'
          }
        };
      }
      try {
        const body = await response.json();
        const errors = (body === null || body === void 0 ? void 0 : body.errors) || [];
        const errorDetail = (body === null || body === void 0 ? void 0 : body.detail) || 'Error deleting cellphone';
        logger.warn('Error deleting cellphone /contacts/v1/customers/me/cellphone:', response.status, errorDetail, JSON.stringify(errors));
        return {
          error: {
            code: response.status,
            message: errorDetail
          }
        };
      } catch (_unused5) {
        logger.error('Error deleting cellphone, /contacts/v1/customers/me/cellphone', response.status);
        return {
          error: {
            code: response.status,
            message: 'Error deleting cellphone'
          }
        };
      }
    }
    return {
      error: null
    };
  } catch (err) {
    logger.warn('Error deleting cellphone', err);
    return {
      error: {
        code: 'network-error',
        message: err === null || err === void 0 ? void 0 : err.message
      }
    };
  }
};
const getTranscriptStatus = async () => {
  const useOldJupiterApi = !svs.core.detect.feature('ft-elza-registerextract');
  if (useOldJupiterApi) {
    try {
      var _response$response, _response$response2;
      const response = await jupiter.callAsync({
        method: 'GET',
        path: '/compliance/1/ordercustomertranscriptstatus',
        data: {}
      });
      if (response !== null && response !== void 0 && response.error) {
        logger.warn('Error fetching transcript status', response === null || response === void 0 ? void 0 : response.error);
      }
      return {
        error: response === null || response === void 0 || (_response$response = response.response) === null || _response$response === void 0 ? void 0 : _response$response.error,
        data: (response === null || response === void 0 || (_response$response2 = response.response) === null || _response$response2 === void 0 || (_response$response2 = _response$response2.getOrderCustomerTranscriptStatusReplyObject) === null || _response$response2 === void 0 ? void 0 : _response$response2.ordersstatus) || []
      };
    } catch (error) {
      logger.warn('Error fetching transcript status', error);
      return {
        error,
        data: null
      };
    }
  }
  try {
    const response = await svsFetch('/compliance/v1/customers/me/orders', {
      method: 'GET'
    });
    if (!response.ok) {
      if (response.status === 401) {
        window.location.href = '/logga-ut';
        return {
          error: {
            code: 401,
            message: 'unauthorized'
          },
          data: null
        };
      }
      try {
        const body = await response.json();
        const errorDetail = (body === null || body === void 0 ? void 0 : body.title) || (body === null || body === void 0 ? void 0 : body.detail) || 'Error fetching transcript status';
        logger.warn('Error fetching transcript status (Elza):', response.status, errorDetail);
        return {
          error: {
            code: response.status,
            message: errorDetail
          },
          data: null
        };
      } catch (_unused6) {
        logger.error('Error fetching transcript status (Elza)', response.status);
        return {
          error: {
            code: response.status,
            message: 'Error fetching transcript status'
          },
          data: null
        };
      }
    }
    const responseData = await response.json();
    const orderTypeToNumber = {
      customerInformation: '1',
      betHistory: '2',
      accountHistory: '3'
    };
    return {
      error: null,
      data: ((responseData === null || responseData === void 0 ? void 0 : responseData.data) || []).map(item => _objectSpread(_objectSpread({}, item), {}, {
        OrderId: item.orderId,
        OrderType: orderTypeToNumber[item.orderType] || item.orderType,
        OrderStatus: item.isReady ? 'READY' : 'NOTREADY',
        OrderDate: item.orderDate
      }))
    };
  } catch (error) {
    logger.warn('Error fetching transcript status (Elza)', error);
    return {
      error,
      data: null
    };
  }
};
const postTranscriptOrdering = async transcriptType => {
  const useOldJupiterApi = !svs.core.detect.feature('ft-elza-registerextract');
  if (useOldJupiterApi) {
    try {
      var _response$response3;
      const response = await jupiter.callAsync({
        path: '/compliance/1/ordercustomertranscript',
        method: 'POST',
        data: {
          transcriptType
        }
      });
      if (response !== null && response !== void 0 && response.error) {
        logger.warn('Error ordering transcript', response === null || response === void 0 ? void 0 : response.error);
      }
      return {
        error: response === null || response === void 0 || (_response$response3 = response.response) === null || _response$response3 === void 0 ? void 0 : _response$response3.error,
        data: response.data || {}
      };
    } catch (error) {
      logger.warn('Error ordering transcript', error);
      return {
        error,
        data: null
      };
    }
  }

  try {
    const response = await svsFetch('/compliance/v1/customers/me/orders', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        orderType: transcriptType
      })
    });
    if (!response.ok) {
      if (response.status === 401) {
        window.location.href = '/logga-ut';
        return {
          error: {
            code: 401,
            message: 'unauthorized'
          },
          data: null
        };
      }
      try {
        const body = await response.json();
        const errorDetail = (body === null || body === void 0 ? void 0 : body.title) || (body === null || body === void 0 ? void 0 : body.detail) || 'Error ordering transcript';
        logger.warn('Error ordering transcript (Elza):', response.status, errorDetail);
        return {
          error: {
            code: response.status,
            message: errorDetail
          },
          data: null
        };
      } catch (_unused7) {
        logger.error('Error ordering transcript (Elza)', response.status);
        return {
          error: {
            code: response.status,
            message: 'Error ordering transcript'
          },
          data: null
        };
      }
    }
    if (response.status === 204) {
      return {
        error: null,
        data: {}
      };
    }
    const responseData = await response.json();
    return {
      error: null,
      data: responseData || {}
    };
  } catch (error) {
    logger.warn('Error ordering transcript (Elza)', error);
    return {
      error,
      data: null
    };
  }
};
const putEmailVerifyAsync = async () => {
  const useOldJupiterApi = true; 

  if (useOldJupiterApi) {
    try {
      const _await$jupiter$callAs7 = await jupiter.callAsync({
          path: '/player/1/email/verify',
          method: 'PUT',
          data: {}
        }),
        response = _await$jupiter$callAs7.response;
      if (response !== null && response !== void 0 && response.error) {
        logger.warn('Error asking for email verification', response === null || response === void 0 ? void 0 : response.error);
      }
      return {
        error: response === null || response === void 0 ? void 0 : response.error
      };
    } catch (error) {
      logger.warn('Error asking for email verification', error);
      return {
        error
      };
    }
  }
  try {
    const response = await svsFetch('/contacts/v1/verifications/me/email/order', {
      method: 'POST'
    });
    if (!response.ok) {
      const errorResult = await response.json();
      const errorCode = errorResult.code || errorResult;
      logger.warn('Error response from /contacts/v1/verifications/me/email/order:', errorCode);
      return {
        error: errorCode
      };
    }
    return {
      error: null
    };
  } catch (error) {
    logger.warn('Error asking for email verification, /contacts/v1/verifications/me/email/order', error);
    return {
      error
    };
  }
};
svs.myProfile.react.pages.myInformation.myInformationService = {
  getTranscriptStatus,
  getCustomerBankAccountsAsync,
  putSendMobileVerificationCodeAsync,
  postCellPhoneAsync,
  postEmailAsync,
  postConfirmMobileNumberAsync,
  deleteCellPhoneAsync,
  getCustomersPreferencesAsync,
  postTranscriptOrdering,
  putEmailVerifyAsync
};

 })(window);